import React, { useState } from 'react';
import api from '../services/api';

const OrdersUpload = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setMessage('');
        setResult(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            setMessage('Пожалуйста, выберите файл');
            return;
        }

        setLoading(true);
        setMessage('');
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await api.uploadOrders(formData);
            
            if (response.data) {
                setResult(response.data);
                if (response.data.success > 0) {
                    setMessage(`Успешно обработано: ${response.data.success} записей`);
                }
                if (response.data.errors > 0) {
                    setMessage(prev => prev + `, Ошибок: ${response.data.errors}`);
                }
            } else {
                setMessage(response.message || 'Файл успешно загружен');
            }
        } catch (error) {
            setMessage('Ошибка загрузки файла');
            console.error('Upload error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page">
            <h2>Загрузка приказов из Excel</h2>
            <p>Загрузите Excel файл с данными приказов</p>
            
            <div className="upload-container">
                <form onSubmit={handleSubmit} className="upload-form">
                    <div className="form-group">
                        <label htmlFor="file">Выберите Excel файл:</label>
                        <input
                            type="file"
                            id="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={loading || !file}
                        className="upload-btn"
                    >
                        {loading ? 'Загрузка...' : 'Загрузить'}
                    </button>
                </form>

                {message && (
                    <div className={`message ${message.includes('Ошибка') ? 'error' : 'success'}`}>
                        {message}
                    </div>
                )}

                {result && (
                    <div className="upload-result">
                        <h4>Результаты обработки:</h4>
                        <div className="result-stats">
                            <div className="stat success">
                                <strong>Успешно:</strong> {result.success}
                            </div>
                            <div className="stat error">
                                <strong>Ошибок:</strong> {result.errors}
                            </div>
                        </div>

                        {result.warnings && result.warnings.length > 0 && (
                            <div className="warnings-section">
                                <h5>Предупреждения и ошибки:</h5>
                                <div className="warnings-list">
                                    {result.warnings.map((warning, index) => (
                                        <div key={index} className="warning-item">
                                            {warning}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="upload-info">
                    <h4>Формат файла для приказов:</h4>
                    <ul>
                        <li>Данные начинаются с 4-й строки</li>
                        <li>Столбец B (2) - Исполнитель</li>
                        <li>Столбец C (3) - ИНН агента</li>
                        <li>Столбец D (4) - Тип документа</li>
                        <li>Столбец E (5) - Исходящий номер</li>
                        <li>Столбец F (6) - Дата документа</li>
                        <li>Столбец G (7) - ФИО владельца</li>
                        <li>Столбец I (9) - Номер лицевого счета</li>
                        <li>Столбец P (16) - Период сбора с</li>
                        <li>Столбец Q (17) - Период сбора по</li>
                        <li>Столбец R (18) - Сумма иска (взнос)</li>
                        <li>Столбец S (19) - Сумма иска (пени)</li>
                        <li>Столбец T (20) - Сумма иска (пошлина)</li>
                        <li>Столбец U (21) - Неиспользованная пошлина</li>
                        <li>Столбец V (22) - Наименование суда</li>
                        <li>Столбец W (23) - Дата принятия</li>
                        <li>Столбец X (24) - Номер дела</li>
                        <li>Столбец Y (25) - Результат рассмотрения</li>
                        <li>Столбец Z (26) - Взыскано (взнос)</li>
                        <li>Столбец AA (27) - Взыскано (пени)</li>
                        <li>Столбец AB (28) - Взыскано (пошлина)</li>
                        <li>Столбец AC (29) - Добровольное исполнение</li>
                        <li>Столбец AD (30) - Дата решения</li>
                        <li>Столбец AE (31) - Дата вступления</li>
                        <li>Столбец AF (32) - Апелляция</li>
                        <li>Столбец AG (33) - Дата выдачи</li>
                        <li>Столбец AH (34) - Исходный номер документа</li>
                        <li>Столбец AI (35) - Дата получения</li>
                        <li>Столбец AJ (36) - Дата исполнения</li>
                        <li>Столбец AK (37) - Учреждение взыскания</li>
                        <li>Столбец AL (38) - Сумма исполнения (взнос)</li>
                        <li>Столбец AM (39) - Сумма исполнения (пени)</li>
                        <li>Столбец AN (40) - Сумма исполнения (пошлина)</li>
                        <li>Столбец AO (41) - Стадия</li>
                        <li>Столбец AP (42) - Сумма ИД (взнос)</li>
                        <li>Столбец AQ (43) - Сумма ИД (пени)</li>
                        <li>Столбец AR (44) - Сумма ИД (пошлина)</li>
                        <li>Столбец AS (45) - Возвращено пошлины</li>
                        <li>Столбец AT (46) - Примечание</li>
                        <li>Столбец AU (47) - Комментарии</li>
                    </ul>
                    
                    <div className="upload-note">
                        <strong>Примечание:</strong> Файл должен соответствовать указанному формату.
                        При загрузке проверяется существование лицевого счета и владельца.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrdersUpload;